
// Helper pour les barres de navigations des formulaires.
// expose saveAttachments(endpoint, encodedFileId, callback)
export default {
  data () {
    return {
      encodedFileId: null,
      endpoint: null,
      uploadAttachmentDone: null,
      refsUpload: [],
      iUpload: 0,
    }
  },
  methods: {
    saveAttachments(endpoint, encodedFileId, callback) {
      this.iUpload = -1;
      this.endpoint = endpoint;
      this.encodedFileId = encodedFileId;
      this.uploadAttachmentDone = callback;

      if (!this.encodedFileId) {
        console.log("error pas de demandeAdmissionId");

        return;
      }

      this.saveNextAttachment();
    },
    saveAttachment() {
      const ref = this.refsUpload[this.iUpload]();

      if (ref?.getTempAttachments.length > 0) {
        ref.startUpload(this.encodedFileId, this.endpoint);
      } else {
        this.saveNextAttachment();
      }
    },
    saveNextAttachment() {
      this.iUpload++;

      if (this.refsUpload.length === this.iUpload) {
        return this.uploadAttachmentDone()
      }

      this.saveAttachment();
    },
  },
}